// extracted by mini-css-extract-plugin
export default {"informationPopupSwiperContainer":"informationPopupSwiperContainer-yQPha3tg","informationPopupSwiperSlide":"informationPopupSwiperSlide-O1fHtSYZ"};